var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"noticia-site"},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('v-form',[_c('PageTitle',{attrs:{"icon":"mdi-pencil-box-outline","main":"Painel de notícias","sub":"Notícias do site","home":"/noticias"}}),_c('div',[_c('noticia')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }